import { useColor } from "@commonlibs";
import { UseStatsChartCardParams } from "../StatsChartCard.types";
import { useMemo } from "react";
import { SimpleDataPoints } from "../../Charts/AreaChart/SimpleAreaChart/SimpleAreaChart.types";
import useFormatDate from "ui/common/hooks/useFormatDate/useFormatDate";

export default function useStatsChartCard({ stats, color: colorProp }: UseStatsChartCardParams) {
    const formatDate = useFormatDate();
    const color = useColor(colorProp) as string;

    const { labels, data } = useMemo(() => {
        const labels: string[] = [];
        const finalData: SimpleDataPoints[] = [
            {
                color,
                values: [],
            },
        ];
        stats?.stats.forEach((item) => {
            labels.push(formatDate(item.label));
            finalData[0].values.push(item.value);
        });
        return {
            labels,
            data: finalData,
        };
    }, [stats]);

    return {
        labels,
        data,
    };
}
